module.exports = __webpack_public_path__ + "media/images/favicon/secondary/favicon-96x96-7d48bb992007e09522228381e83916e1.png";